import {addAllProduct,cartList,selectOptions,deleteOptions,moreSkus,submitPH,submitPH2} from "../../../api/main/cart.js";
let modules = {
	namespaced: true,
	state: {


	},
	mutations: {
		
	},
	actions: {
		doAddAllProduct(conText, payload){
			addAllProduct(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},
		getCartList(conText, payload){//进货车列表
			cartList(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},
		doSelectOptions(conText, payload){//进货车选中/取消商品
			selectOptions(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},
		doDeleteOptions(conText, payload){//进删除进货车商品
			deleteOptions(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},
		getMoreSkus(conText, payload){//选择更多产品分类
			moreSkus(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},
		doSubmitPH(conText, payload){//提交铺货
			submitPH(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},
		async doSubmitPHBatch(conText, payload){//每家店独立创建手动铺货任务
			const shops = payload.shops
			const results = new Array(shops.length)
			let nextIndex = 0
			const worker = async () => {
				while (nextIndex < shops.length) {
					const index = nextIndex++
					const shop = shops[index]
					try {
						const res = await submitPH({shop_ids: [shop.shop_id], product_ids: payload.product_ids})
						results[index] = {
							shop_id: shop.shop_id,
							shop_name: shop.shop_name,
							success: res.code === 200,
							message: res.message || res.msg || '提交失败'
						}
					} catch (error) {
						results[index] = {
							shop_id: shop.shop_id,
							shop_name: shop.shop_name,
							success: false,
							message: (error.response && error.response.data && error.response.data.message) || error.message || '请求失败'
						}
					}
				}
			}
			await Promise.all(Array.from({length: Math.min(2, shops.length)}, () => worker()))
			return results
		},
		doSubmitPH2(conText, payload){//一键重铺
			submitPH2(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},
		
	}

}
export default modules;
